import React from 'react';
import { Link } from 'react-router-dom';
import './static-page.scss';
import PropTypes from 'prop-types';

/* eslint-disable max-len */
const CollateralInfo = ({ match }) => (
  <div className="bb-page-wrapper static-page good-beef-page-list without-menu">
    <h1 className="non-highlight">Collateral Information</h1>
    <nav>
      <ul className="page-list">
        <li><Link to={`${match.url}`}>American perspective on Grass-Fed</Link></li>
        <li><Link to={`${match.url}`}>Scientific papers (Ben Gurion, Florida and Michigan)</Link></li>
      </ul>
    </nav>
  </div>
);

CollateralInfo.propTypes = {
  match: PropTypes.shape({
    url: PropTypes.string
  })
};

export default CollateralInfo;
